/**
 * FAQ da LP de tablet de mesa (/tablet).
 */

module.exports = [
  {
    title: 'Quanto custa o Cardápio Digital no tablet?',
    text: 'Os preços variam conforme o plano escolhido. Em qualquer plano, o investimento é muito menor que o custo de um garçom, e o retorno vem rápido com mais vendas e menos erros.',
  },
  {
    title: 'Qual é o tempo de retorno do investimento?',
    text: 'O retorno vem rápido, em semanas. O Cardápio Digital aumenta o ticket médio, reduz erros de pedido e libera a equipe para atender melhor.',
  },
  {
    title: 'Funciona junto com delivery e balcão?',
    text: 'Sim. Mesa, balcão e delivery são integrados no ZaperMenu, você decide quais produtos aparecem no tablet e quais aparecem no cardápio de delivery',
  },
  {
    title: 'Ainda vou precisar de garçons?',
    text: 'Sim, mas você provavelmente não vai precisar aumentar a equipe em dias de maior movimento. O Cardápio Digital agiliza o atendimento e libera a equipe para atender melhor.',
  },
  {
    title: 'Preciso comprar os tablets de vocês?',
    text: 'Não. Você usa os tablets Android que já tem ou compra onde preferir — nós fornecemos o software completo para você agilizar o atendimento e vender mais.',
  },
];
